import React, { useState } from "react";
import { Container, Form, Button, Card } from "react-bootstrap";
import { Link } from "react-router-dom";
import authService from "../services/authService";

const ResetPasswordComponent = () => {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [isError, setIsError] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleResetPassword = async (event) => {
    event.preventDefault();
    setIsSubmitting(true);
    setMessage(""); // Clear any previous messages

    try {
      const result = await authService.resetPassword(email);

      setIsError(!result.success); // Set error state opposite of success
      setMessage(result.message);
    } catch (error) {
      setIsError(true);
      setMessage(error.message || "An error occurred while resetting password");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <Container
      className="d-flex justify-content-center align-items-center"
      style={{ minHeight: "100vh" }}
    >
      <div className="row w-100 justify-content-center">
        <div className="col-12 col-md-6">
          <Card>
            <Card.Body>
              <div className="text-center mb-4">
                <img
                  src="/images/plasticise-logo.png"
                  alt="Company Logo"
                  className="img-fluid mb-4"
                  style={{ maxHeight: "150px", maxWidth: "150px" }}
                />
              </div>

              <h2 className="text-center mb-4">Reset Password</h2>

              <Form onSubmit={handleResetPassword}>
                <Form.Group className="mb-3" controlId="formBasicEmail">
                  <Form.Control
                    type="email"
                    placeholder="Enter email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                    disabled={isSubmitting}
                  />
                  
                </Form.Group>

                <Button
                  variant="primary"
                  type="submit"
                  className="w-100"
                  disabled={isSubmitting}
                >
                  {isSubmitting ? "Sending..." : "Send Reset Link"}
                </Button>

                {message && (
                  <div
                    className={`text-center mt-3 ${
                      isError ? "text-danger" : "text-success"
                    }`}
                  >
                    <h5 className="mb-2">{message}</h5>
                  </div>
                )}
              </Form>

              <div className="text-center mt-3">
                <Link to="/" className="text-muted">
                  Return to Login
                </Link>
              </div>
            </Card.Body>
          </Card>
        </div>
      </div>
    </Container>
  );
};

export default ResetPasswordComponent;
